import listActionTypes from "./actiontypes"
import { libraryCategoriesListStateSelector } from "./selectors"
import LibraryCategoriesAPI from "../api"
import { fetchingItemsFlowFactory } from "core/factories/actions"

const {
  FETCH_LIST_REQUEST,
  FETCH_LIST_SUCCESS,
  FETCH_LIST_FAILURE,
  FETCH_LIST,
} = listActionTypes

export default function* listFetchingFlow() {
  yield* fetchingItemsFlowFactory(
    {
      fetch: FETCH_LIST,
      request: FETCH_LIST_REQUEST,
      success: FETCH_LIST_SUCCESS,
      failure: FETCH_LIST_FAILURE,
    },
    () => LibraryCategoriesAPI.fetchList,
    () => libraryCategoriesListStateSelector
  )()
}
